var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"notebook",class:[_vm.inText && 'in-text'],attrs:{"src":require('@/assets/icons/i-notizbuch.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }